import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { ProductReviewsContainer } from '../../../../../containers/ProductReviewsContainer'
import { SearchReviewInput } from '../SearchReviewInput'

import { DesktopDelimiter, Header, MobileDelimiter, SearchWrapper, Title, Wrapper } from './styles'

export const ProductReviewsHeader = () => {
  const {
    magnolia: {
      reviewsPage: { reviewsTotalTitle },
    },
  } = useTranslation()

  const { results } = ProductReviewsContainer.useContainer()

  if (!results?.totalReviews || results.totalReviews < 1) return null

  return (
    <Header>
      <Wrapper>
        <Title>
          {reviewsTotalTitle.text}{' '}
          {results.totalFilteredReviews ? results.totalFilteredReviews : results.totalReviews}{' '}
          {results.totalReviews === 1 ? reviewsTotalTitle.suffix : reviewsTotalTitle.pluralSuffix}
        </Title>
        <MobileDelimiter />
        <SearchWrapper>
          <SearchReviewInput />
        </SearchWrapper>
      </Wrapper>
      <DesktopDelimiter />
    </Header>
  )
}
